<template>
  <section class="home-services-section section-spacing">
    <div class="custom_container_store mt-3">
      <div class="row">
        <div class="col-lg-3 box_shadow_search">
          <img
            v-if="searchFranchise != ''"
            src="@/assets/imgs/svg/red-cross.svg"
            alt=""
            class="cross_icon"
            @click="clearSearch()"
          />
          <input
            type="text"
            v-model="searchFranchise"
            placeholder="Search Offices..."
            class="searchBar w-100 mb-0"
          />
          <div class="store_count mb-1">
            Offices: {{ filteredFranchiseList.length }}
          </div>
        </div>
        <div
          class="col-lg-9 d-flex align-items-center w-100 flex-wrap mobie_view_btn_wrapper"
        >
          <button
            v-for="(elem, index) in areaName"
            @click="handleButtonClick(elem.area)"
            :key="index"
            :class="
              elem.area == searchFranchise
                ? `btn-secondary-red`
                : `btn-secondary-white`
            "
            style="padding: 0.3rem"
            :style="elem.area != searchFranchise ? 'box-shadow:none' : ''"
          >
            {{ elem.area }}
          </button>
        </div>
      </div>

      <b-tabs
        v-model="tabIndex"
        pills
        card
        vertical
        justified
        class="custom-vertical-tabs map_tabs_custom"
        nav-wrapper-class="col-12 col-lg-3"
        :active-nav-item-class="tabsActive ? 'tab-active' : ''"
        align="center"
        style="height: 100%"
        v-if="filteredFranchiseList.length > 0"
      >
        <template v-for="(elem, index) in filteredFranchiseList">
          <b-tab no-body :active="elem[0]" class="custom-tab" :key="index">
            <template #title>
              <div class="custom-tab-title">
                <h4 class="h4 tabs-title custom_responsive_margin_">
                  {{ elem.name }}
                </h4>

                <p class="para custom_responsive_margin_">
                  <!-- <svg
                    version="1.0"
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="17"
                    viewBox="0 0 512.000000 512.000000"
                    preserveAspectRatio="xMidYMid meet"
                  >
                    <g
                      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                      fill="#427CEA"
                      stroke="none"
                    >
                      <path
                        d="M2430 5114 c-229 -26 -360 -54 -508 -109 -392 -147 -720 -416 -943 -775 -210 -339 -307 -778 -259 -1170 78 -631 528 -1501 1274 -2465 176 -228 403 -501 455 -548 69 -62 153 -62 222 0 52 47 279 320 455 548 671 867 1102 1655 1238 2267 35 157 46 259 46 423 -1 480 -193 939 -540 1285 -286 287 -623 460 -1020 525 -94 15 -352 27 -420 19z m247 -925 c373 -50 682 -318 783 -679 27 -95 37 -286 21 -390 -47 -296 -241 -556 -516 -690 -162 -79 -328 -109 -497 -90 -132 15 -199 34 -313 90 -275 134 -469 394 -516 690 -16 104 -6 295 21 390 125 446 566 741 1017 679z"
                      />
                    </g>
                  </svg> -->
                  <img
                    src="@/assets/imgs/franchise/Poniter.svg"
                    class="locator_pointer_img"
                  />
                  {{ elem.address }}
                </p>
                <div class="d-flex flex-wrap justify-content-between">
                  <p
                    class="para custom_responsive_margin_"
                    v-if="elem.phone != ''"
                  >
                    <img
                      src="@/assets/imgs/franchise/Phone.svg"
                      class="locator_pointer_img"
                    />
                    <!-- <svg
                      width="18"
                      height="17"
                      viewBox="0 0 18 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.5569 10.8063L12.1019 11.2375C12.1019 11.2375 11.0189 12.2617 8.06386 9.46502C5.10886 6.66833 6.19186 5.64408 6.19186 5.64408L6.47786 5.37183C7.18486 4.70359 7.25186 3.62985 6.63486 2.84548L5.37486 1.24342C4.61086 0.27248 3.13586 0.143974 2.26086 0.97213L0.690856 2.4571C0.257856 2.86832 -0.032144 3.39949 0.002856 3.98967C0.092856 5.50034 0.810856 8.74919 4.81486 12.5397C9.06186 16.5586 13.0469 16.7185 14.6759 16.5738C15.1919 16.5281 15.6399 16.2787 16.0009 15.9361L17.4209 14.592C18.3809 13.6848 18.1109 12.1284 16.8829 11.4935L14.9729 10.5045C14.1669 10.0885 13.1869 10.2104 12.5569 10.8063Z"
                        fill="#427CEA"
                      />
                    </svg> -->
                    <a
                      :href="'tel:' + elem.phone"
                      :style="
                        tabIndex == index ? 'color: #212529' : 'color: #212529'
                      "
                    >
                      {{ elem.phone }}</a
                    >
                  </p>
                  <p class="para" v-if="elem.email != ''">
                    <img
                      src="@/assets/imgs/franchise/email_2099199.svg"
                      class="locator_pointer_img"
                    />
                    <!-- <svg
                      version="1.0"
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="17"
                      viewBox="0 0 512.000000 512.000000"
                      preserveAspectRatio="xMidYMid meet"
                      class="locator_pointer_img"
                    >
                      <g
                        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                        fill="#427CEA"
                        stroke="none"
                      >
                        <path
                          d="M366 4464 c-255 -62 -415 -322 -351 -569 20 -75 57 -143 107 -195 45 -46 2175 -1471 2253 -1506 119 -54 260 -52 382 5 95 45 2182 1442 2235 1496 249 254 113 686 -243 770 -94 22 -4291 21 -4383 -1z"
                        />
                        <path
                          d="M0 2236 c0 -810 3 -1181 11 -1218 37 -176 179 -320 360 -363 94 -22 4267 -22 4372 0 182 38 329 184 366 363 13 61 16 2386 3 2380 -4 -1 -487 -323 -1074 -715 -587 -392 -1099 -729 -1139 -748 -110 -56 -204 -77 -339 -77 -135 0 -229 21 -339 77 -40 19 -552 356 -1139 748 -587 392 -1070 714 -1074 715 -5 2 -8 -521 -8 -1162z"
                        />
                      </g>
                    </svg> -->
                    <a
                      :href="'mailto:' + elem.email"
                      :style="
                        tabIndex == index ? 'color: #212529' : 'color: #212529'
                      "
                    >
                      {{ elem.email }}</a
                    >
                  </p>
                </div>

                <div
                  class="d-flex justify-content-around align-items-center mobile_responsive_alignment flex-wrap"
                >
                  <button
                    v-if="elem.know_more_path != ''"
                    @click="knowMoreRedirect(elem.know_more_path)"
                    class="btn know_more_btn"
                    style="padding: 0.5rem"
                  >
                    Know More
                  </button>
                  <img
                    src="@/assets/imgs/franchise/google-maps_2642502.png"
                    @click.prevent="preventDefaultAction(elem.directionUrl)"
                    style="width: 10%"
                    class="destop_map_icon_logo"
                  />
                </div>
              </div>
            </template>

            <div class="text-center mt-2 mt-lg-0">
              <iframe
                :src="elem.iframe_src"
                class="map_iframe"
                style="border: 0"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </b-tab>
        </template>
      </b-tabs>
      <div class="error" v-if="filteredFranchiseList.length == 0">
        <p>Franchise Not Found</p>
      </div>
    </div>
    <!-- <div class="text-center mt-4">
      <button
        @click="() => $router.push({ path: '/abroad-counselling' })"
        class="btn btn-secondary-red"
      >
        Know More
      </button>
    </div> -->
  </section>
</template>

<script>
export default {
  name: "MapFranchiseService",
  data() {
    return {
      searchFranchise: "",
      baseUrl: "",
      tabsActive: true,
      percentageValue: 0,
      tabIndex: 0,
      tabs: [true, false, false, false],
      OnclickFranchiseArea: "",
      // intVal: "",
      franchiseData: [
        {
          name: "Head Office, Mumbai",
          area: "Mumbai",
          address:
            "203, God's Gift Tower, Swami Vivekananda Rd, next to Lucky Hotel, Madam Wadi, Santosh Nagar, Bandra West, Mumbai, Maharashtra 400050.",
          phone: "+91 9987099890",
          email: "info@aliff.in",
          director_name: "Aliff Overseas",
          know_more_path: "https://aliff.in/abroad-counselling",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3771.2207809957663!2d72.83486327454942!3d19.05402815266324!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c93cf278c8ed%3A0x71bea878054a3c56!2sAliff%20Overseas%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1713506447228!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//203,+Aliff+Overseas+Pvt+Ltd,+God's+Gift+Tower,+Swami+Vivekananda+Rd,+next+to+Lucky+Hotel,+Madam+Wadi,+Santosh+Nagar,+Bandra+West,+Mumbai,+Maharashtra+400050/@19.0540282,72.8348633,17z/data=!4m17!1m7!3m6!1s0x3be7c93cf278c8ed:0x71bea878054a3c56!2sAliff+Overseas+Pvt+Ltd!8m2!3d19.0540231!4d72.8374382!16s%2Fg%2F1td08dcn!4m8!1m0!1m5!1m1!1s0x3be7c93cf278c8ed:0x71bea878054a3c56!2m2!1d72.8374382!2d19.0540231!3e9?entry=ttu",
          near_by: "",
        },

        {
          name: "Thane Office, Thane",
          area: "Thane",
          address:
            "Happy Valley, Patlipada, Thane West, Thane, Maharashtra 400607.",
          phone: "+91 8591603321",
          email: "kajal@aliff.in",
          director_name: "Kajal Mistry",
          know_more_path: "/thane-office",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3767.0394717816075!2d72.96917437455389!3d19.237111446896222!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7bbe0cf85996d%3A0x82b478eb85c41c49!2sA14!5e0!3m2!1sen!2sin!4v1710244941332!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//A14+6XPC%2BRMX+Happy+Valley+Patlipada,+Thane+West,+Thane,+Maharashtra+400607/@19.2371064,72.9717493,17z/data=!4m5!4m4!1m0!1m2!1m1!1s0x3be7bbe0cf85996d:0x82b478eb85c41c49",
          near_by: "",
        },
        {
          name: "Baroda Office, Vadodara",
          area: "Baroda",
          address:
            "205.A WING, 2nd Floor, Siddharth Excellence, New Vasana Rd, Saraswati Society, Tandalja, Vadodara, Gujarat 390012.",
          phone: "+91 9321306252",
          email: "shabana@aliff.in",
          director_name: "Shabana Khan",
          know_more_path: "/vadodara-office",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.5626278408313!2d73.15146127463639!3d22.294551843105015!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc620c03121f7%3A0xe141965129efbfdb!2sSiddharth%20Excellence%2C%20B%20R%20Patel%20Group!5e0!3m2!1sen!2sin!4v1710245119691!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//Siddharth+Excellence,+B+R+Patel+Group+75V3%2BRJ7+New+Vasana+Rd,+Saraswati+Society,+Tandalja+Vadodara,+Gujarat+390012/@22.2945469,73.1540362,17z/data=!4m5!4m4!1m0!1m2!1m1!1s0x395fc620c03121f7:0xe141965129efbfdb",
          near_by: "",
        },
        {
          name: "Mira Road Office, Thane",
          area: "Thane",
          address:
            "C-78, Shanti Shopping Center, Opp Mira Road Railway Station, Mira Road (E), Thane 401 107. Maharashtra.",
          phone: "+91 9152549789",
          email: "preeti@aliff.in",
          director_name: "Preeti Ganju",
          know_more_path: "/miraroad-office",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3766.0479703397364!2d72.85220777325635!3d19.280280005694284!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b04ddc954f31%3A0x5446cc0c7968ca23!2sShanti%20Shopping%20Centre%2C%20opp.%20Mira%20Road%20Railway%20Station%2C%20Shanti%20Vihar%2C%20Mira%20Road%20East%2C%20Thane%2C%20Mira%20Bhayandar%2C%20Maharashtra%20401107!5e0!3m2!1sen!2sin!4v1710245293570!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//Shanti+Shopping+Centre+opp.+Mira+Road+Railway+Station+Shanti+Vihar,+Mira+Road+East+Thane,+Mira+Bhayandar,+Maharashtra+401107/@19.280275,72.8568212,17z/data=!4m5!4m4!1m0!1m2!1m1!1s0x3be7b04ddc954f31:0x5446cc0c7968ca23",
          near_by: "Dahisar,Bhayandar",
        },
        {
          name: "Lower Parel Office, Mumbai",
          area: "Mumbai",
          address:
            "1001, 10th Floor,Marathon Icon,Opp. Peninsula Corporate Park, Off, Ganapatrao Kadam Marg, Lower Parel West, Mumbai, Maharashtra 400013.",
          phone: "+91 9167693427",
          email: "infolp@aliff.in",
          director_name: "Snehas Ajgaonkar",
          know_more_path: "/lowerparel-office",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3772.508661812123!2d72.82230417454802!3d18.99729475443996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7ce8da76aa5e5%3A0xdf0700cf117d1f6e!2sMarathon%20Icon!5e0!3m2!1sen!2sin!4v1710245456622!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//Marathon+Icon+Opp.+Peninsula+Corporate+Park+Off,+Ganapatrao+Kadam+Marg,+Lower+Parel+West+Mumbai,+Maharashtra+400013/@18.9972897,72.8248791,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3be7ce8da76aa5e5:0xdf0700cf117d1f6e!2m2!1d72.8248791!2d18.9972897?entry=ttu",
          near_by: "",
        },
        {
          name: "Raipur Office, Raipur",
          area: "Raipur",
          address:
            "Shop No 62 RDA Complex, Bhakta Mata karma Commercial Complex, Bombay Hwy, near GBG Kidney Care Clinic, New Rajendra Nagar, Raipur, Chhattisgarh 492001.",
          phone: "+91 9967971967",
          email: "raipur@aliff.in",
          director_name: "Bishwajit Chakraborty",
          know_more_path: "/Raipur-office",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3719.163085067319!2d81.6534372735802!3d21.22538063786227!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a28dd93c7a3719f%3A0xb0b6d3e70c9bd26f!2sRDA%20Complex!5e0!3m2!1sen!2sin!4v1710246082953!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//RDA+Complex+6MG5%2B563+Bhakta+Mata+karma+Commercial+Complex+Mumbai+Hwy,+near+GBG+Kidney+Care+Clinic,+New+Rajendra+Nagar,+Raipur,+Chhattisgarh+492001/@21.2253757,81.6580507,17z/data=!4m5!4m4!1m0!1m2!1m1!1s0x3a28dd93c7a3719f:0xb0b6d3e70c9bd26f",
          near_by: "",
        },
        {
          name: "Solapur Office, Solapur",
          area: "Solapur",
          address:
            "971, First floor,Hotel Orient Elite Balives Rd, South Kasba, Budhavar Peth, Solapur, Maharashtra 413001.",
          phone: "+91 7977664053",
          email: "sanket@aliff.in",
          director_name: "Sanket Thobade",
          know_more_path: "/solapur-office",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3801.349094564587!2d75.90217627451716!3d17.680961494282844!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc5db648d5674d3%3A0x36192411937abb5b!2s%231%20Top%20Hotel%20in%20Solapur%20%7C%20Hotel%20Orient%20Elite!5e0!3m2!1sen!2sin!4v1710573083967!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//%231+Top+Hotel+in+Solapur+%7C+Hotel+Orient+Elite+Balives+Rd+South+Kasba,+Budhavar+Peth+Solapur,+Maharashtra+413001/@17.6809564,75.9047512,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bc5db648d5674d3:0x36192411937abb5b!2m2!1d75.9047512!2d17.6809564?entry=ttu",
          near_by: "",
        },

        {
          name: "Navi Mumbai Office, Belapur",
          area: "Belapur",
          address:
            "301, Kukreja Plaza, A-wing, Rajiv Gandhi Road, Sector 11, CBD Belapur, Navi Mumbai, Maharashtra 400614.",
          phone: "+91 9137120368",
          email: "charushila@aliff.in",
          director_name: "Charu Singh",
          know_more_path: "/belapur-office",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1886.0373205703481!2d73.04123778847364!3d19.01643233137426!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c2534e9ef3a1%3A0xe818b44ba40f6271!2sKukreja%20Plaza!5e0!3m2!1sen!2sin!4v1710573138714!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//Kukreja+Plaza+47,+Rajiv+Gandhi+Road+Sector+11,+CBD+Belapur+Navi+Mumbai,+Maharashtra+400614/@19.0154808,73.040956,18z/data=!4m5!4m4!1m0!1m2!1m1!1s0x3be7c2534e9ef3a1:0xe818b44ba40f6271",
          near_by: "",
        },

        {
          name: "Karnataka Office, Hubballi",
          area: "Karnataka",
          address:
            "Shop No.10C,Gokul Restaurant Bus Stand, Gokul Rd, opposite New, Industrial Estate, Hubballi, Karnataka 580030.",
          phone: "+91 8369387894",
          email: "nikita@aliff.in",
          director_name: "Nikita Keshav",
          know_more_path: "/hubballi-office",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d240.4669942592768!2d75.1172501193424!3d15.350994309838974!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb8d72374414437%3A0xf218e8fa1b414c7d!2sGokul%20Restaurant!5e0!3m2!1sen!2sin!4v1710573259668!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//Gokul+Restaurant+Bus+Stand+Gokul+Rd,+opposite+New,+Industrial+Estate+Hubballi,+Karnataka+580030/@15.351072,75.117259,21z/data=!4m5!4m4!1m0!1m2!1m1!1s0x3bb8d72374414437:0xf218e8fa1b414c7d",
          near_by: "",
        },
        {
          name: "Deccan Office, Pune",
          area: "Pune",
          address:
            "St Crispin's Home, Second floor, Left Wing, Karve Rd, Bhalekar Chawl, Erandwane, Pune, Maharashtra 411004.",
          phone: "+91 8655244122",
          email: "siddharth@aliff.in",
          director_name: "Rutvij Jadhav",
          know_more_path: "/deccan-office",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.445343538271!2d73.82931287453621!3d18.508766669536097!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bf92815ddf69%3A0xa43f65d79e227a23!2sSt%20Crispin;s%20Home!5e0!3m2!1sen!2sin!4v1710415322818!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//Deccan+Gymkhana+Pune,+Maharashtra+411004/@18.5165436,73.8366021,16z/data=!4m5!4m4!1m0!1m2!1m1!1s0x3bc2bf8f302a2f7d:0xae8576b1d65c2e64",
          near_by: "",
        },

        {
          name: "Karve Road Office, Pune",
          area: "Pune",
          address:
            "Goodwill House,Shankarao Joshi Rd, Pandurang Colony, Erandwane, Pune, Maharashtra 411004.",
          phone: "+91 7021247812",
          email: "sandeep@aliff.in",
          director_name: "Sandeep Dravid",
          know_more_path: "/karveRoad-office",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.4879365692327!2d73.83218524064266!3d18.50683978860097!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bf8d0fdf4e97%3A0x96d38c317293d58a!2sGoodwill%20House!5e0!3m2!1sen!2sin!4v1710573423340!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//Goodwill+House+1,+Shankarao+Joshi+Rd+Pandurang+Colony,+Erandwane+Pune,+Maharashtra+411004/@18.5068294,73.832236,17z/data=!4m5!4m4!1m0!1m2!1m1!1s0x3bc2bf8d0fdf4e97:0x96d38c317293d58a",
          near_by: "",
        },

        {
          name: "Pimple Saudagar Office, Pune",
          area: "Pune",
          address:
            "Flat no A1/606, Kate Vasti Rd Daffodils Housing Society, Kunj Colony, Pimple Saudagar, Pimpri-Chinchwad, Maharashtra 411027.",
          phone: "+91 7977630464",
          email: "sudeshna@aliff.in",
          director_name: "Sudeshna B",
          know_more_path: "/pimple-office",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3781.641692975821!2d73.8011895745382!3d18.590185767045483!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b8db7e4ac07d%3A0xbc95a29e18026530!2sKate%20Vasti%20Rd%2C%20Daffodils%20Housing%20Society%2C%20Kunj%20Colony%2C%20Pimple%20Saudagar%2C%20Pimpri-Chinchwad%2C%20Maharashtra%20411027!5e0!3m2!1sen!2sin!4v1710573507273!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//Kate+Vasti+Rd+Daffodils+Housing+Society,+Kunj+Colony,+Pimple+Saudagar+Pimpri-Chinchwad,+Maharashtra+411027/@18.5901807,73.8037645,17z/data=!4m5!4m4!1m0!1m2!1m1!1s0x3bc2b8db7e4ac07d:0xbc95a29e18026530",
          near_by: "",
        },
        {
          name: "Coimbatore Office, Tamil Nadu",
          area: "Tamil Nadu",
          address:
            "A1, 742, TST Complex, Avinashi Road, Land mark- Near Anna Silai, Coimbatore, TamilNadu – 641018.",
          phone: "+91 8169345554",
          email: "coimbatore@aliff.in",
          director_name: "Sudeshna B",
          know_more_path: "/coimbatore-office",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3781.641692975821!2d73.8011895745382!3d18.590185767045483!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b8db7e4ac07d%3A0xbc95a29e18026530!2sKate%20Vasti%20Rd%2C%20Daffodils%20Housing%20Society%2C%20Kunj%20Colony%2C%20Pimple%20Saudagar%2C%20Pimpri-Chinchwad%2C%20Maharashtra%20411027!5e0!3m2!1sen!2sin!4v1710573507273!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//Kate+Vasti+Rd+Daffodils+Housing+Society,+Kunj+Colony,+Pimple+Saudagar+Pimpri-Chinchwad,+Maharashtra+411027/@18.5901807,73.8037645,17z/data=!4m5!4m4!1m0!1m2!1m1!1s0x3bc2b8db7e4ac07d:0xbc95a29e18026530",
          near_by: "",
        },
        {
          name: "Ambattur Chennai Office, Tamil Nadu",
          area: "Tamil Nadu",
          address:
            "No.1, Ground Floor, SSV Complex, 19/3B1A Noombal Road, Goparasanallur (Near Arvind Eye Hospital, PH Road), Chennai 600077",
          phone: "+91 9321131583",
          email: "ambatturchennai@aliff.in",
          director_name: "Abdul Gafoor",
          know_more_path: "/ambattur-chennai-office",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3781.641692975821!2d73.8011895745382!3d18.590185767045483!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b8db7e4ac07d%3A0xbc95a29e18026530!2sKate%20Vasti%20Rd%2C%20Daffodils%20Housing%20Society%2C%20Kunj%20Colony%2C%20Pimple%20Saudagar%2C%20Pimpri-Chinchwad%2C%20Maharashtra%20411027!5e0!3m2!1sen!2sin!4v1710573507273!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//Kate+Vasti+Rd+Daffodils+Housing+Society,+Kunj+Colony,+Pimple+Saudagar+Pimpri-Chinchwad,+Maharashtra+411027/@18.5901807,73.8037645,17z/data=!4m5!4m4!1m0!1m2!1m1!1s0x3bc2b8db7e4ac07d:0xbc95a29e18026530",
          near_by: "",
        },
        {
          name: "OMR Chennai Office, Tamil Nadu",
          area: "Tamil Nadu",
          address:
            "Workafella 4th Floor, Tower A, TEK MEADOWS, 51, Rattha, SH 49A, OMR, Sholinganallur, Chennai Tamil Nadu 600119.",
          phone: "+91 9137501830",
          email: "omrchennai@aliff.in",
          director_name: "Mushtaq Ahmed",
          know_more_path: "/omr-chennai-office",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3781.641692975821!2d73.8011895745382!3d18.590185767045483!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b8db7e4ac07d%3A0xbc95a29e18026530!2sKate%20Vasti%20Rd%2C%20Daffodils%20Housing%20Society%2C%20Kunj%20Colony%2C%20Pimple%20Saudagar%2C%20Pimpri-Chinchwad%2C%20Maharashtra%20411027!5e0!3m2!1sen!2sin!4v1710573507273!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//Kate+Vasti+Rd+Daffodils+Housing+Society,+Kunj+Colony,+Pimple+Saudagar+Pimpri-Chinchwad,+Maharashtra+411027/@18.5901807,73.8037645,17z/data=!4m5!4m4!1m0!1m2!1m1!1s0x3bc2b8db7e4ac07d:0xbc95a29e18026530",
          near_by: "",
        },
        {
          name: "Dubai Office, Mankhool",
          area: "Dubai",
          address: "1304 11B St-Al Mankhool-Dubai-United Arab Emirates.",
          phone: "+971 585805879",
          email: "dubai@aliff.in",
          director_name: "Shalini Singh",
          know_more_path: "/dubai-office",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3608.576974380969!2d55.29788647472887!3d25.251169329513758!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f432435189a65%3A0xc5073d7389491124!2sAl%20Falasi%20Residence%20-%2011B%20St%20-%20Al%20Mankhool%20-%20Dubai%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2sin!4v1710266862064!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//Al+Falasi+Residence+11B+St+Al+Mankhool+-+Dubai+United+Arab+Emirates/@25.2511645,55.3004614,17z/data=!4m5!4m4!1m0!1m2!1m1!1s0x3e5f432435189a65:0xc5073d7389491124",
          near_by: "",
        },

        {
          name: "Kuwait Office, Kuwait",
          area: "Kuwait",
          address:
            "Office No. 508, floor-5, Al-Rehab Complex Tunisia St, Kuwait City, Kuwait",
          phone: "+965 50633207",
          email: "hina@aliff.in",
          director_name: "Hina Saleem",
          know_more_path: "/kuwait-office",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3478.1700847121574!2d48.02307477487692!3d29.336010751789292!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3fcf9cf41f144621%3A0xc9f38b62d94554a4!2sAl-Rehab%20Complex%2C%20Tunisia%20St%2C%20Kuwait%20City%2C%20Kuwait!5e0!3m2!1sen!2sin!4v1710355818769!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//Al-Rehab+Complex+Tunisia+St+Kuwait+City+Kuwait/@29.3360061,48.0256497,15z/data=!4m5!4m4!1m0!1m2!1m1!1s0x3fcf9cf41f144621:0xc9f38b62d94554a4",
          near_by: "",
        },
        {
          name: "Kolkata Office",
          area: "Kolkata",
          address:
            "Technico India P137 Hemanta Mukhopadhyay Sarani (Lake Terrace) Kolkata 700029",
          phone: "+91 8104356049",
          email: "kolkotta@aliff.in",
          director_name: "Koyeli Dutt",
          know_more_path: "/kolkata-office",
          iframe_src:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3478.1700847121574!2d48.02307477487692!3d29.336010751789292!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3fcf9cf41f144621%3A0xc9f38b62d94554a4!2sAl-Rehab%20Complex%2C%20Tunisia%20St%2C%20Kuwait%20City%2C%20Kuwait!5e0!3m2!1sen!2sin!4v1710355818769!5m2!1sen!2sin",
          directionUrl:
            "https://www.google.com/maps/dir//Al-Rehab+Complex+Tunisia+St+Kuwait+City+Kuwait/@29.3360061,48.0256497,15z/data=!4m5!4m4!1m0!1m2!1m1!1s0x3fcf9cf41f144621:0xc9f38b62d94554a4",
          near_by: "",
        },
      ],
      areaName: [
        { area: "Mumbai" },
        { area: "Thane" },
        { area: "Pune" },
        { area: "Vadodara" },
        { area: "Raipur" },
        { area: "Solapur" },
        { area: "Navi Mumbai" },
        { area: "Karnataka" },
        { area: "Tamil Nadu" },
        { area: "Kolkata" },
        { area: "Dubai" },
        { area: "Kuwait" },
      ],
    };
  },
  // watch: {
  //   franchiseData: {
  //     deep: true,
  //     handler(newValue, oldValue) {
  //       console.log(newValue, "newValue");
  //     },
  //   },
  // },
  computed: {
    filteredFranchiseList() {
      console.log(this.OnclickFranchiseArea, "this.OnclickFranchiseArea");
      return this.franchiseData.filter((val) => {
        return (
          val.name.toLowerCase().includes(this.searchFranchise.toLowerCase()) ||
          val.address
            .toLowerCase()
            .includes(this.searchFranchise.toLowerCase()) ||
          val.near_by.toLowerCase().includes(this.searchFranchise.toLowerCase())
        );
      });
    },
    scrollWin() {
      window.scrollBy(0, 100);
    },
  },

  methods: {
    handleButtonClick(value) {
      this.searchFranchise = value;

      // Store the selected value in the variable
    },

    preventDefaultAction(url) {
      window.open(url, "_blank");
    },
    knowMoreRedirect(url) {
      console.log("Working", url);
      if (!url.includes("abroad-counselling")) {
        const routeData = this.$router.resolve({ path: url });
        window.open(routeData.href, "_blank");
      } else {
        window.open(url, "_blank");
      }
    },
    clearSearch() {
      console.log("clicked");
      this.searchFranchise = "";
    },
    tabsTimer() {
      const r = document.querySelector(":root");
      let tabNo = 0;
      let intVal = "";
      intVal = setInterval(() => {
        if (this.percentageValue < 100) {
          this.percentageValue += 1;
          // r.style.setProperty("--percentage", this.percentageValue + "%");
        } else {
          this.percentageValue = 0;
          // console.log(tabNo);
          this.$set(this.tabs, tabNo, false);
          this.$set(this.tabs, (tabNo + 1) % 4, true);

          if (tabNo == 3) {
            tabNo = 0;
            this.$set(this.tabs, tabNo, true);
          } else {
            tabNo = tabNo + 1;
          }

          // console.log(this.tabs, tabNo);

          if (this.$route.name != "home") {
            clearInterval(this.intVal);
          }
          // intVal();
        }
      }, 50);
    },
  },
  beforeMount() {
    if (this.$route.name == "home") {
      this.tabsTimer();
    }
    this.baseUrl = window.location.origin;
  },
};
</script>

<style>
.locator_pointer_img {
  width: auto !important;
}
.map_tabs_custom .nav-pills {
  height: 500px !important;
  flex-wrap: nowrap !important;
  overflow-y: scroll !important;
  padding-left: 0px;
  padding-right: 0.5rem;
  padding-top: 0px;
}
/* .searchBar {
    background: #eaf4fe;
    border: none;
    border-radius: 7px;
    padding: 10px;
  } */

.error p {
  color: #000;
  font-weight: bold;
  font-size: 30px;
  text-align: center;
}
.cross_icon {
  position: absolute;
  right: 30px;
  bottom: 60px;
  cursor: pointer;
}
.map_iframe {
  width: 100%;
  height: 500px;
}
p {
  font-size: 14px !important;
}
.custom_responsive_margin_ {
  margin: 0px;
}
@media (max-width: 767px) {
  .map_tabs_custom .nav-pills {
    height: 320px !important;

    flex-wrap: wrap !important;
    overflow-x: scroll !important;
    overflow-y: hidden !important;
    gap: 20px;
  }
  .mobile_responsive_alignment {
    flex-wrap: wrap;
    gap: 20px;
  }
}
@media (max-width: 991px) {
  .custom_responsive_margin_ {
    margin-bottom: 12px;
  }
  p {
    font-size: 15px !important;
  }
  .error p {
    font-size: 25px;
  }
  .map_iframe {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/MapFranchiseService.vue